"use client";
import { createContext, ReactNode, useEffect } from "react";

interface IProps {
	children: ReactNode;
}
interface Theme {
	name: string;
	color: string;
}

const ThemeWrapperProvider = createContext(null);

const ThemeWrapper = ({ children }: IProps) => {
	return <ThemeWrapperProvider.Provider value={null}>{children}</ThemeWrapperProvider.Provider>;
};

export default ThemeWrapper;
